export const getCurrentTab = (pathname: string): string => {
  const pathParts = pathname.split("/")

  if (pathParts[3] === "form" && pathParts[4]) {
    return `${pathParts[3]}/${pathParts[4]}`
  }

  return pathParts[3]
}

export const getCustomerId = (pathname: string): string => {
  return pathname.split("/")[2]
}
